export const toIsoLocalString = (str) => {
  // Expect "yyyy-MM-dd HH:mm"
  //   if (!str.includes(" ")) return str;
  //   return str.replace(" ", "T");

  console.log("toIsoLocalString input:", str);
  if (!str || typeof str !== "string") return str;

  // If it's already ISO-like with 'T', just return as-is
  if (str.includes("T")) return str;

  // Split date / time
  const [datePart, timePart] = str.split(" ");
  if (!datePart || !timePart) return str;

  // Case 1: dd/MM/yyyy HH:mm  →  yyyy-MM-ddTHH:mm
  if (datePart.includes("/")) {
    const [day, month, year] = datePart.split("/");
    if (!day || !month || !year) return str;

    const yyyy = year;
    const MM = month.padStart(2, "0");
    const dd = day.padStart(2, "0");

    return `${yyyy}-${MM}-${dd}T${timePart}`;
  }

  // Case 2: yyyy-MM-dd HH:mm  →  yyyy-MM-ddTHH:mm
  if (datePart.includes("-")) {
    // assume it's already yyyy-MM-dd
    return `${datePart}T${timePart}`;
  }

  // Fallback: unknown format, return as-is
  return str;
};
